var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26325 10.7931C5.83954 10.986 5.43715 11.2123 5.06257 11.47C3.51066 12.5383 2.46772 14.0961 2.04674 15.9744C1.99049 16.2198 1.98494 16.4762 2.03048 16.7243C2.07602 16.9724 2.17149 17.2059 2.30973 17.4072C2.44005 17.5929 2.60698 17.7429 2.79767 17.8457C2.98836 17.9485 3.19773 18.0012 3.40966 18H16.5914C16.8026 18.0012 17.0113 17.9486 17.2015 17.8464C17.3916 17.7441 17.5581 17.5948 17.6883 17.41C17.8269 17.2089 17.9227 16.9757 17.9688 16.7277C18.0148 16.4797 18.0099 16.2233 17.9543 15.9778C17.5353 14.0767 16.4909 12.51 14.9355 11.4472C14.5621 11.192 14.1654 10.9692 13.749 10.7799C12.7627 11.8416 11.4447 12.5001 10.001 12.5001C8.56278 12.5001 7.24942 11.8465 6.26325 10.7931Z",
    fill: "currentColor",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.001 11C9.00082 11 8.03374 10.5306 7.2768 9.67864C6.54078 8.84767 6.09129 7.73955 6.012 6.55932C5.92735 5.30034 6.29269 4.14261 7.04038 3.29886C7.78807 2.45511 8.83348 2 10.001 2C11.1602 2 12.2086 2.4633 12.9538 3.305C13.7064 4.15489 14.0727 5.31057 13.988 6.55881C13.9068 7.74057 13.4578 8.84818 12.7232 9.67812C11.9682 10.5306 11.0016 11 10.001 11Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContacts);
export default __webpack_public_path__ + "static/media/icon-contacts.1885a5d82f4198b2c1eb0cee387d5d9c.svg";
export { ForwardRef as ReactComponent };